jQuery(($) => {

    if ($('.o-wide-content-block--is-slider')[0]) {
        var dotsNavigation   = $('.o-wide-content-block__dots-navigation'),
            arrowsNavigation = $('.o-wide-content-block__arrows-navigation');

        $('.o-wide-content-block--is-slider .o-wide-content-block__list').slick({
            dots: true,
            arrows: true,
            appendDots: dotsNavigation,
            appendArrows: arrowsNavigation,
            swipetoSlide: false,
        }); 
    } 
}); 